import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { BrowserRouter } from 'react-router-dom';
render(<BrowserRouter data-id="element-238">
    <App data-id="element-239" />
  </BrowserRouter>, document.getElementById('root'));